// extracted by mini-css-extract-plugin
module.exports = {"destest":"camplanding_destest__rY8FU","facultySection":"camplanding_facultySection__hZrsi"};